import type { ReactNode } from 'react';

import { isMobileWebview } from 'helpers/isMobileWebview';

export interface MobileAwareWebsiteLinkProps {
  url: string;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function MobileAwareWebsiteLink({ url, children, className, ariaLabel }: MobileAwareWebsiteLinkProps) {
  if (isMobileWebview()) {
    return (
      <a
        href="#"
        className={className}
        aria-label={ariaLabel}
        onClick={(e) => {
          e.preventDefault();
          window.ReactNativeWebView?.postMessage(`webview:${url}`);
          window.postMessage(`webview:${url}`, '*');
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className={className} aria-label={ariaLabel}>
      {children}
    </a>
  );
}
